var e = {
	title: "Notifications",
	feed: { empty: "You have no notifications yet." },
	grouping: {
		newForYou: "New for you",
		earlierThisWeek: "Earlier this week",
		earlier: "Earlier"
	},
	reviewReply: { viewReply: "View reply" },
	modificationRequested: {
		respondBy: "Respond by {{when}}",
		reviewRequest: "Review request"
	},
	recentSearchReminder: { resumeSearch: "Pick up your search" },
	checkoutAbandoned: { finishBooking: "Finish booking" },
	roomReadyForArrival: { openToday: "Open today's board" },
	roomNeedsCleaning: { openRoom: "Open room" }
};
//#endregion
export { e as default };
